// Used by OOI styles to store the applied preset name.
export const APPLIED_PRESET_FIELD = '$$$presetName$$$';
